export const deleteEdge = async (edgeToDelete, setEdges, api) => {
    if (!edgeToDelete) {
        console.log("No edge found to delete.");
        return;
      }
  
      if (edgeToDelete.data?.edgeId) {
  
        api.flowEdge
          .delete(edgeToDelete.data.edgeId)
          .then(() => {
          })
          .catch((error) => {
            console.error(
              `Failed to delete edge with ID ${edgeToDelete.data.edgeId}:`,
              error
            );
          });
      }

      setEdges((prevEdges) =>
        prevEdges.filter((edge) => edge.id !== edgeToDelete.id)
      );
};